import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	ctaLoggedInIneligible: {
		id: 'subpage.hero.ctaLoggedInIneligible',
		defaultMessage: 'Subscribe to Calm',
		description: 'Button text for when a user is logged in but not eligible for the free trial',
	},
	ctaActiveSub: {
		id: 'subpage.hero.ctaActiveSub',
		defaultMessage: 'Continue to App',
		description: 'Button text for when a user is logged in and has an active subscription',
	},
	buttonAriaLabel: {
		id: 'subpage.hero.buttonAriaLabel',
		defaultMessage: 'Scroll to next section',
		description: 'Alt text for button that scrolls user to next section',
	},
});
